import { CommonModule } from '@angular/common';
import { Component, computed, Input, input, InputSignal, OnInit, output, signal, Signal, WritableSignal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-bundle-edition',
  imports: [MatFormFieldModule, MatSelectModule, CommonModule],
  templateUrl: './bundle-edition.component.html',
  styleUrl: './bundle-edition.component.scss'
})
export class BundleEditionComponent implements OnInit {

  //#region Inputs
  product: InputSignal<any> = input.required();

  toggleId: InputSignal<string> = input.required();
  //#endregion

  //#region Outputs
  outToggleContent = output();

  outUpdateProduct = output<{ product: any }>();
  //#endregion

  //#region Signals
  removedBundleItems: WritableSignal<Map<string, any>> = signal(new Map());

  bundleHasPendingChanges: WritableSignal<boolean> = signal(false);

  private bundleClone: WritableSignal<{ items: any[] } | null> = signal<{ items: any[] } | null>(null);

  //#endregion

  //#region Computed Properties
  bundle: Signal<any> = computed(() => this.product().bundle);

  //#endregion

  //#region Observables
  private product$ = toObservable(this.product);
  //#endregion

  ngOnInit() {
    this.product$.subscribe(product => {
      this.clearBundleEdits();
      const bundleClone = JSON.parse(JSON.stringify(product.bundle));
      this.bundleClone.set(bundleClone);
    });
  }

  onChangeInputBundleItem(bundleProduct: any, event: Event) {
    const newValue = (event.target as HTMLInputElement).value;
    // Update the bundle product quantity
    bundleProduct.quantity = newValue;
    this.validateBundlePendingChanges();
  }

  onChangeQuantityBundleItem(bundleProduct: any, event: MatSelectChange<any>) {
    const newValue = event.value;
    // Update the bundle product quantity
    bundleProduct.quantity = newValue;
    this.validateBundlePendingChanges();
  }

  removeProductFromBundle(bundleProduct: any) {
    // Remove the product from the bundle
    this.bundle().items = this.bundle().items.filter((item: { id: any; }) => item.id !== bundleProduct.id);
    this.removedBundleItems()?.set(bundleProduct.id, bundleProduct);
    this.validateBundlePendingChanges();
  }

  restoreBundleProduct(bundleProduct: any) {
    // Restore the product to the bundle
    this.removedBundleItems()?.delete(bundleProduct.id);
    this.bundle().items.push(bundleProduct);
    this.validateBundlePendingChanges();
  }

  private validateBundlePendingChanges() {
    // Check if the bundle items length is different from the clone
    if (this.bundle().items.length !== this.bundleClone()?.items.length) {
      this.bundleHasPendingChanges.set(true);
      return;
    }
    // check if the quantity of any bundle item has changed comparing to the clone
    for (const item of this.bundle().items) {
      const cloneItem = this.bundleClone()?.items.find(i => i.id === item.id);
      if (cloneItem && cloneItem.quantity !== item.quantity) {
        this.bundleHasPendingChanges.set(true);
        return;
      }
    }
    this.bundleHasPendingChanges.set(false);
  }

  saveBundleChanges() {
    const product = {
      ...this.product(),
      bundle: { ...this.bundle() },
      isUpdatingBundle: true
    };

    this.outUpdateProduct.emit({ product });
  }

  discardBundleEdits() {
    // Set into bundle the products from clone
    this.bundle().items = JSON.parse(JSON.stringify(this.bundleClone()?.items));
    this.clearBundleEdits();
  }

  private clearBundleEdits() {
    this.removedBundleItems()?.clear();
    this.bundleHasPendingChanges.set(false);
  }

}

